import { render, staticRenderFns } from "./jiangPinList.vue?vue&type=template&id=07b44446&scoped=true&"
import script from "./jiangPinList.vue?vue&type=script&lang=js&"
export * from "./jiangPinList.vue?vue&type=script&lang=js&"
import style0 from "./jiangPinList.vue?vue&type=style&index=0&id=07b44446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b44446",
  null
  
)

export default component.exports